import React from 'react'
import { Document } from '../landingpage/components/document';
import { Footer } from '../landingpage/components/footer';
import { Util } from '../fasades/util';

export class Founder extends React.Component {
    render() {
        return (
            <>

            <title>Meet Erlend Grønnevet - Founder of TigerCity.ai</title>
            <meta
                    name="description"
                    content="Meet Erlend Grønnevet, founder of TigerCity.ai. With a Master's in AI from NTNU and 40+ years of experience, discover the passion driving Norway's next AI success."
            />
            <link rel="canonical" href={Util.getTigerCityUrl() + "docs/founder"}/>

            <div className="scroll">
            <div className="document-view">
            <Document classes="main">
                <h1>Meet Erlend Grønnevet - Founder of TigerCity.ai</h1>

                <h2>Erlend Grønnevet</h2>
                <p>Passionate AI engineer and innovator with a deep-rooted passion for advancing artificial intelligence and developing cutting-edge technologies. With over four decades of experience in programming and a Master's degree in AI, Erlend has consistently pushed the boundaries of technology, driving impactful solutions in the field.</p>

                <h2>Career Journey</h2>
                <p>Erlend began his journey in 1982, diving into programming on the Vic-20, where he honed his skills in technical innovation. This early fascination led him to pursue a Master's in AI at NTNU in 1996, where he laid the foundation for his expertise in artificial intelligence. In 1998, he joined IFS, where he worked on Demand Planner and AI-related projects, further refining his skills in AI engineering and technical innovation.</p>

                <h2>Expertise</h2>
                <p>Erlend's expertise spans AI engineering, technical innovation, and delivering scalable solutions. His ability to bridge the gap between theoretical AI concepts and practical implementation has made him a sought-after professional in the tech industry.</p>

                <h2>Commitment to Tigercity.ai</h2>
                <p>Erlend is dedicated to tigercity.ai, a platform he has been instrumental in building over the past 2.5 years. As a platform for fine-tuning large language models (LLMs), tigercity.ai leverages Erlend's extensive experience in AI to provide powerful tools for researchers and developers. His commitment to this project reflects his belief in the transformative potential of AI technology.</p>
            </Document>
            </div>
                <Footer/>
            </div>
            </>
        )
    }
}

